import React from 'react';
import { Container, Row, Col, Card, Button, Badge, Accordion, Image } from 'react-bootstrap';

import hammockBeach from "../assets/img/hammock-beach.webp";
import chrisClinic from "../assets/img/chris_circle.png";
import skipClinic from "../assets/img/skip_circle.png";
import {Helmet} from "react-helmet";

export default function EventPage() {
    return (
        <>
        <Helmet>
            <title>Dual Force Golf School | MyGolfDNA.com</title>
            <meta
                name="description"
                content="Join Chris Tyler and Skip Kendall at Hammock Beach Golf Resort & Spa, Nov 8–10, 2025. Two days of expert golf instruction, oceanfront lodging, and on-course play."
            />
        </Helmet>
        <div>
            {/* Hero Header */}
            <div
                className="hero-header d-flex align-items-center justify-content-center text-white"
                style={{
                    backgroundImage: `url(${hammockBeach})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    height: "60vh"
                }}
            >
                <div className="text-center">
                    <h1 className="display-4 fw-bold">Dual Force Golf School</h1>
                    <p className="lead">November 8th – 10th | Hammock Beach Golf Resort & Spa</p>
                    <Button variant="light" size="lg" href="https://square.link/u/pAOjoPkb">Reserve Your Spot</Button>
                </div>
            </div>

            <style>{`
        @media (max-width: 768px) {
          .hero-header {
            height: 40vh !important;
          }
          .hero-header h1 { font-size: 1.75rem; }
          .hero-header p { font-size: 1rem; }
        }
      `}</style>

            {/* Floating Reserve button styles */}
            <style>{`
        .fab-reserve { display: none; }
        @media (max-width: 576px) {
          .fab-reserve {
            display: inline-flex;
            position: fixed;
            left: 50%;
            transform: translateX(-50%);
            bottom: 16px;
            z-index: 1050;
            width: calc(100% - 2rem);
            justify-content: center;
            border-radius: 999px;
            box-shadow: 0 10px 24px rgba(0,0,0,0.2);
          }
        }
      `}</style>

            {/* Mobile spacing tweaks */}
            <style>{`
        @media (max-width: 576px) {
          #tickets .card-body { padding: 1.25rem 1.25rem 1.5rem; }
          #tickets .btn { padding: 0.9rem 1.1rem; font-size: 1.05rem; }
          .container, .container-fluid { padding-left: 1rem; padding-right: 1rem; }
        }
      `}</style>

            {/* Content */}
            <Container className="py-4">
                <Row>
                    {/* Main Content */}
                    <Col xs={12} md={8} className="order-0 order-md-0">
                        {/* Overview */}
                        <h2>Overview</h2>
                        <p>
                            Join us for an immersive golf school designed to sharpen your short game,
                            build compression, and advance your skills with expert coaches Chris and Skip.
                        </p>
                        <div className="d-grid d-sm-inline">
                            <a href="https://square.link/u/pAOjoPkb" className="btn btn-primary btn-lg mb-3">Reserve Your Spot</a>
                        </div>
                        <hr className="my-4" />

                        {/* Schedule */}
                        <h2 id="schedule" className="mt-5">Schedule</h2>
                        <ul>
                            <li><strong>Day 1 - Saturday</strong>
                                <ul>
                                    <li>8:30 - 9:30 Welcome Meeting at the Hammock House</li>
                                    <li>9:30 - 12:00 Intro to Short Game and Compression School</li>
                                    <li>12:00 - 1:00 Lunch at the Hammock House</li>
                                    <li>1:00 - 4:00 Short Game and Compression School</li>
                                </ul>
                            </li>
                            <li><strong>Day 2 - Sunday</strong>
                                <ul>
                                    <li>8:30 - 9:30 Day 1 Recap | Q&A</li>
                                    <li>9:30 - 12:00 Advancing Your Skills</li>
                                    <li>12:00 - 1:00 Lunch at the Hammock House</li>
                                    <li>1:00 - 2:00 Warm up and prep for 9 on course play</li>
                                    <li>2:00 - 4:00 9 holes with Skip and Chris</li>
                                </ul>
                            </li>
                            <li><strong>Day 3 - Monday Optional Private Instruction</strong>
                                <ul>
                                    <li>8:00 - 1:00 Slots available. Please contact <a href="mailto:chris@mygolfdna.com">chris@mygolfdna.com</a> to book private instruction add on.</li>
                                </ul>
                            </li>
                        </ul>

                        {/* Coaches */}
                        <h2 className="mt-5">Meet the Coaches</h2>
                        <Row className="mb-5">
                            <Col md={6} className="text-center mb-4">
                                <Image
                                    src={chrisClinic}
                                    roundedCircle
                                    fluid
                                    alt="Chris"
                                    className="mb-3"
                                    style={{ maxWidth: "200px" }}
                                />
                                <h5>Chris Tyler</h5>
                                <p>Founder of MyGolfDNA.com, redefining virtual golf instruction for players worldwide.</p>
                            </Col>
                            <Col md={6} className="text-center mb-4">
                                <Image
                                    src={skipClinic}
                                    roundedCircle
                                    fluid
                                    alt="Skip"
                                    className="mb-3"
                                    style={{ maxWidth: "200px" }}
                                />
                                <h5>Skip Kendall</h5>
                                <p>25 Year PGA Tour Veteran, Short Game Specialist.</p>
                            </Col>
                        </Row>

                        {/* Location */}
                        <h2>Location</h2>
                        <p>Hammock Beach Golf Resort & Spa</p>
                        <p>200 Ocean Crest Dr, Palm Coast, FL 32137</p>
                        <div className="ratio ratio-16x9 mb-4">
                            <iframe
                                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3489.694934449621!2d-81.2078!3d29.6054!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e72c3a2e6e4e37%3A0x2a730f3e5e3cbbf!2sHammock%20Beach%20Golf%20Resort%20%26%20Spa!5e0!3m2!1sen!2sus!4v1691762345678"
                                width="600"
                                height="450"
                                style={{ border: 0 }}
                                allowFullScreen=""
                                loading="lazy"
                                title="Hammock Beach Map"
                            ></iframe>
                        </div>

                        {/* FAQ */}
                        <h2>FAQ</h2>
                        <Accordion>
                            <Accordion.Item eventKey="0">
                                <Accordion.Header>What should I bring?</Accordion.Header>
                                <Accordion.Body>
                                    Comfortable golf attire, clubs, and a positive attitude!
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1">
                                <Accordion.Header>Is lodging included?</Accordion.Header>
                                <Accordion.Body>
                                    Yes, your 2-night stay in the Ocean View Terrace is included.
                                </Accordion.Body>
                            </Accordion.Item>
                        </Accordion>
                    </Col>

                    {/* Tickets Sidebar */}
                    <Col xs={12} md={4} className="order-1 order-md-1 mt-4 mt-md-0" id="tickets">
                        <Card className="">
                            <Card.Body>
                                <h3>Get Access</h3>
                                <p><strong>Price:</strong> $2997.00 per person</p>
                                <p><strong>Early Bird Price:</strong> $1997.00 per person (valid until midnight September 14th, 2025)</p>
                                <p><strong>When:</strong> November 8th – 10th</p>
                                <p><strong>What's Included:</strong> 2 Full days of instruction, 2 night stay in Ocean View Terrace, Lunch, 9 holes of golf on day 2.</p>
                                <p>Extended stay / Additional Occupancy is available. Please lock in your spot first and then contact <a href="mailto:chris@mygolfdna.com">chris@mygolfdna.com</a> to add on.</p>
                                <Button variant="primary" size="lg" className="w-100" href="https://square.link/u/pAOjoPkb">Reserve Your Spot</Button>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>


        </div>
            </>
    );
}
